import { jsx as _jsx } from "react/jsx-runtime";
import { AssetStatusType } from '@design-stack-vista/vista-assets-sdk';
import { observer } from 'mobx-react-lite';
import { DrawerThumbnailDeleteIndicator } from './DrawerThumbnailDeleteIndicator';
import { useDrawerThumbnailAsset } from './DrawerThumbnailAssetProvider';
import { useLocalization } from '../../../../Localization';
export const DrawerThumbnailDeletingStatus = observer(() => {
    const { asset: { status }, } = useDrawerThumbnailAsset();
    const { deletingLabel } = useLocalization();
    if (!deletingLabel) {
        // We can't have a button without a title
        throw Error('You must define a deletingLabel in the Localization Provider');
    }
    if (status.type !== AssetStatusType.Deleting) {
        return null;
    }
    return _jsx(DrawerThumbnailDeleteIndicator, { title: deletingLabel });
});
DrawerThumbnailDeletingStatus.displayName = 'DrawerThumbnailDeletingStatus';
//# sourceMappingURL=DrawerThumbnailDeletingStatus.js.map